import { render } from "./BookSession.vue?vue&type=template&id=58124eb1"
import script from "./BookSession.vue?vue&type=script&lang=js"
export * from "./BookSession.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__